import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Navigates to +href+ when the row is clicked or activated with Enter/Space.
// Ignores clicks on interactive descendants (links, buttons, form controls).
export default class extends Controller {
  static values = { href: String, frame: String }

  click(event) {
    if (event.target.closest("a, button, input, select, textarea, label, [data-signed-id], [data-file-id]")) {
      return
    }
    event.preventDefault()
    this.visit()
  }

  keydown(event) {
    if (event.target.closest("a, button, input, select, textarea, label, [data-signed-id], [data-file-id]")) {
      return
    }
    if (!(event.key === "Enter" || event.key === " ")) {
      return
    }
    event.preventDefault()
    this.visit()
  }

  visit() {
    const options = this.hasFrameValue ? { frame: this.frameValue } : {}
    Turbo.visit(this.hrefValue, options)
  }
}
